import {styled} from "@mui/material/styles"
import {Select} from "@mui/material"

export const Cashmere25StyledSelectSort = styled(Select)`
    display: flex;
    .MuiSelect-select {
        font-size: ${({theme}) => theme.colours.components.inputText.fontSize};
        font-weight: ${({theme}) => theme.colours.components.inputText.fontWeight};
        font-family: ${({theme}) => theme.colours.components.inputText.fontFamily};
        letter-spacing: ${({theme}) => theme.colours.components.inputText.letterSpacing};
        &.MuiSelect-outlined {
            &.MuiInputBase-input {
                padding: 0.5rem 1rem;
                border-radius: 0.25rem;
            }
        }
    }
    &.MuiInputBase-root {
        color: ${({theme}) => theme.colours.form.input.sortPlaceholder};
        height: 2.25rem;
    }
    &.Mui-focused > :focus-visible {
        outline: ${({theme}) => `0.125rem solid ${theme.colours.palette.info.other.focusRingColor}`};
        outline-offset: 1px;
        border-radius: 0.25rem;
    }
    & .MuiOutlinedInput-notchedOutline {
        border-color: ${({theme}) => theme.colours.form.input.borderColor};
    }
    border-radius: 0.25rem;
    & > div {
        text-transform: ${({theme}) => theme.colours.components.inputLabel2.textTransform};
        font-size: ${({theme}) => theme.colours.components.inputLabel2.fontSize};
    }
    & li {
        text-transform: ${({theme}) => theme.colours.components.inputLabel2.textTransform};
        font-size: ${({theme}) => theme.colours.components.inputLabel2.fontSize};
    }
`
